import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslate } from '~/i18n';

const faq = [
   {
      question: 'Viverra cras suspendisse elit est. ',
      answer:
         'Habitant in magna sollicitudin posuere sit quis. Duis morbi commodo, elementum odio amet tempor, erat ut. Aliquam et eget tincidunt sed in odio. Aliquam posuere turpis nam senectus posuere lacinia.',
   },
   {
      question: 'Viverra cras suspendisse elit est. ',
      answer:
         'Habitant in magna sollicitudin posuere sit quis. Duis morbi commodo, elementum odio amet tempor, erat ut. Aliquam et eget tincidunt sed in odio. Aliquam posuere turpis nam senectus posuere lacinia.',
   },
   {
      question: 'Viverra cras suspendisse elit est. ',
      answer:
         'Habitant in magna sollicitudin posuere sit quis. Duis morbi commodo, elementum odio amet tempor, erat ut. Aliquam et eget tincidunt sed in odio. Aliquam posuere turpis nam senectus posuere lacinia.',
   },
   {
      question: 'Viverra cras suspendisse elit est. ',
      answer:
         'Habitant in magna sollicitudin posuere sit quis. Duis morbi commodo, elementum odio amet tempor, erat ut. Aliquam et eget tincidunt sed in odio. Aliquam posuere turpis nam senectus posuere lacinia.',
   },
   {
      question: 'Viverra cras suspendisse elit est. ',
      answer:
         'Habitant in magna sollicitudin posuere sit quis. Duis morbi commodo, elementum odio amet tempor, erat ut. Aliquam et eget tincidunt sed in odio. Aliquam posuere turpis nam senectus posuere lacinia.',
   },
];

export const FAQ = () => {
   const [opened, setOpen] = useState(0);
   const ref = useRef<HTMLDetailsElement | null>(null);
   const { lang } = useTranslate();

   useEffect(() => {
      const focusElement = (el?: HTMLElement | null) => {
         if (!el || !el.focus) return;
         el.focus();
      };

      const listen = (event: KeyboardEvent) => {
         const target = event.target as HTMLElement;
         const detailEl = target.parentNode;
         const currentIdx = Number(target.getAttribute('data-index'));
         const isUp = event.code === 'ArrowUp';
         const isDown = event.code === 'ArrowDown';

         if (isUp && currentIdx > 0) {
            const prev = detailEl?.previousSibling?.firstChild as HTMLElement;
            focusElement(prev);
         } else if (isDown && faq.length > currentIdx) {
            const next = detailEl?.nextSibling?.firstChild as HTMLElement;
            focusElement(next);
         }
      };

      if (ref.current) {
         window.addEventListener('keyup', listen);
      }

      return () => {
         window.removeEventListener('keyup', listen);
      };
   }, []);

   return (
      <div className="mt-20">
         {/* To remove the arrow from the details element in IOS, add the following CSS to your global styles: */}
         <style jsx global>{`
            details summary::-webkit-details-marker {
               display: none;
            }
            details > summary {
               list-style: none;
            }
            details > summary::-webkit-details-marker {
               display: none;
            }
         `}</style>

         <div className="mb-8 text-black text-center font-bold text-5xl ">
            Frequently asked questions
         </div>
         <div className="text-center mb-24 font-medium text-[#6E757C] text-2xl">
            Do you have any questions about Hala Yalla? See the list below for our most frequently
            asked questions. If your question is not listed here, then please{' '}
            <Link href={lang === 'sa-en' ? '/sa-en' + '/contact' : 'sa/ar' + '/contact'}>
               <a className="text-[#1D4ED8]">contact us</a>
            </Link>
         </div>
         {faq.map((q, i) => (
            <details
               className="group m-2 mb-5"
               key={i}
               open={i === opened}
               onClick={e => {
                  e.preventDefault();
                  const idx = i === opened ? -1 : i;
                  setOpen(idx);
               }}
               ref={ref}>
               <summary
                  className={`list-none cursor-pointer rounded-xl border-2 
                      !border-[#e9ecef80] bg-white hover:bg-slate-100 active:bg-slate-200
                      group-active:rounded-b-none focus:!outline-none 
                      ${i !== opened ? '' : 'rounded-b-none'}`}
                  data-index={i}>
                  <p className="p-4 text-2xl !outline-none  font-medium flex justify-between items-center">
                     {q.question}
                     <img
                        src="/images/tickets-page/chevron-down.svg"
                        className={i == opened ? 'rotate-180' : ''}
                     />
                  </p>
               </summary>
               <div className="text-lg text-[#4A5056] border-b-2 border-l-2 border-r-2 !border-[#e9ecef80] bg-[#FCFCFC] p-4 rounded-b-xl ">
                  {q.answer}
               </div>
            </details>
         ))}
      </div>
   );
};
